import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import PrivateRoute from "./PrivateRoute";
import Dashboard from "./components/dashboard/Dashboard";
import GuestPass from './components/gates/GuestPass';
import Home from "./components/dashboard/Home";
import { connect } from 'react-redux';

import './App.css';
class App extends Component {
    render() {
        return (
            <BrowserRouter>
                <div className="App">
                    <Switch>
                        <Route exact path='/'           component={Home}/>
                        <Route path='/admin'            component={Dashboard}/>
                        <Route path="/guest/:gate/:key" component={GuestPass} />
                        {/* <Route exact path='/'                           component={Home}/> */}
                        {/* <PrivateRoute path='/my-account' exact          component={MyAccount}/> */}
                        {/* <PrivateRoute path='/portal/(users?)' exact     component={PortalUserList}/> */}
                        {/* <PrivateRoute path='/portal/user/:id' exact     component={UserList}/> */}
                    </Switch>
                </div>
            </BrowserRouter>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loggedIn: state.loggedIn,
        auth: state.firebase.auth
    };
};

export default connect(mapStateToProps)(App);
